import React from 'react'
import { I18n } from '@front/volcanion/'
import { OptionUtils } from '@front/volcanion/utils'

import { Typography, Grid, Box, StepLabel, StepContent } from '@mui/material'

import { ModelMenuSelectorField } from '@front/squirtle'

const Row1 = props =>
  <Grid container spacing={1}>
    <Grid size="grow">
      <ModelMenuSelectorField
        name={'customerinfo.driver_options'}
        label={I18n.t('options.useroption.label', { count: 1 })}
        model_name={'useroption'}
        searchMode={'search'}
        multiple
        config={{
          initial_filter: {},
          mutator: elem => ({
            label: OptionUtils.getLabel(elem), user_option_id: elem.user_option_id
          })
        }}
      />
    </Grid>
    <Grid size="grow">
      <ModelMenuSelectorField
        name={'customerinfo.vehicle_options'}
        label={I18n.t('options.vehicleoption.label', { count: 1 })}
        model_name={'vehicleoption'}
        searchMode={'search'}
        multiple
        config={{
          initial_filter: {},
          mutator: elem => ({
            label: OptionUtils.getLabel(elem), vehicle_option_id: elem.vehicle_option_id
          })
        }}
      />
    </Grid>
  </Grid>

const OptionSection = props => <>
  <StepLabel>
    <Typography variant='h5'> {I18n.t('options.label', { count: 2 })} </Typography>
  </StepLabel>
  <StepContent >
    <Box sx={{ p: 2, boxShadow: 6, borderRadius: 1 }}>
      <Grid container rowSpacing={2}>
        <Grid size={12}>
          <Row1 {...props} />
        </Grid>
      </Grid>
    </Box>
  </StepContent>
</>

export default React.memo(OptionSection)
